export default __webpack_public_path__ + "static/media/2.a4e52848.png";